"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _initEvent = _interopRequireDefault(require("./initEvent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ALLOY_EVENTS_PREVIEWS = _index.context.ALLOY_EVENTS_PREVIEWS;
var state = {
  data: (0, _initEvent["default"])(),
  addType: function addType(type) {
    this.data.eventTypes.add(type);
    if (!this.data.type) this.data.type = type;
  },
  getEvent: function getEvent() {
    return {
      event: this.data.type,
      xdm: {
        web: {
          webPageDetails: this.data.webPageDetails,
          webInteraction: this.data.webInteraction
        },
        productListItems: this.data.productListItems,
        commerce: this.data.commerce,
        search: this.data.search,
        media: this.data.media
      }
    };
  },
  reset: function reset(pushedEvent) {
    var newData = (0, _initEvent["default"])();
    if (window.__CONTEXT__ !== ALLOY_EVENTS_PREVIEWS) {
      var webPageDetails = pushedEvent === null || pushedEvent === void 0 ? void 0 : pushedEvent.xdm.web.webPageDetails;
      if (webPageDetails) newData.webPageDetails = (0, _cloneDeep2["default"])(webPageDetails);
    }
    this.data = newData;
  }
};
var _default = exports["default"] = state;